import { omit } from 'lodash'

import {
  UPDATE_KEYWORDS_METRICS,
  KeywordsSDBank,
  KEY_KEYWORDS_SD_VALUE,
  LOAD_KEYWORDS_FROM_CACHE,
  ADD_REPORT_ID_TO_POLLING,
  REMOVE_REPORT_IDS_FROM_POLLING,
  SET_POLLING,
  mergeKeywordsSd,
  UPDATE_METRICS_LIMITS,
} from '../actions/sdManager'
import { generateKey } from '../../utils/functions'
import { getMaxValuesForUser } from '../../utils/freeVersionBlock'
import { KEYWORD_METRICS } from '../../utils/consts.mjs'

const { KEYWORD_METRICS_UPDATE_LIMITS, KEYWORD_METRICS_UPDATE_USED } =
  getMaxValuesForUser()
const initialState = {
  metricsLimits: {
    used: KEYWORD_METRICS_UPDATE_USED,
    limits: KEYWORD_METRICS_UPDATE_LIMITS,
  },
  keywords: {},
  reportIds: [],
  metric: KEYWORD_METRICS.SD,
  isPolling: false,
  isFailed: false,
}
const sdManagerReducer = (state = initialState, action = undefined) => {
  let resultState = null
  switch (action.type) {
    case LOAD_KEYWORDS_FROM_CACHE.success:
      resultState = {
        ...state,
        keywords: action.keywords,
      }
      break
    case SET_POLLING.action:
      resultState = {
        ...state,
        isPolling: action.isPolling,
      }
      break
    case ADD_REPORT_ID_TO_POLLING.action:
      resultState = {
        ...state,
        reportIds: [...state.reportIds, action.reportId],
      }
      break
    case REMOVE_REPORT_IDS_FROM_POLLING.action:
      resultState = {
        ...state,
        reportIds: state.reportIds.filter(
          (reportId) => !action.reportIds.some((id) => id === reportId),
        ),
      }
      break
    case UPDATE_METRICS_LIMITS.action:
      resultState = {
        ...state,
        metricsLimits: {
          used:
            action.payload.monthly_keyword_metrics_updates_used ||
            KEYWORD_METRICS_UPDATE_USED,
          limits:
            action.payload.monthly_keyword_metrics_updates_limits ||
            KEYWORD_METRICS_UPDATE_LIMITS,
        },
        isFailed: false,
      }
      break
    case UPDATE_KEYWORDS_METRICS.polling:
    case UPDATE_KEYWORDS_METRICS.success: {
      const keywords = mergeKeywordsSd(
        state.keywords,
        action.payload.newKeywords,
      )
      resultState = {
        ...state,
        keywords,
        metric: action.payload.metric,
        isFailed: false,
      }
      KeywordsSDBank.setItem(KEY_KEYWORDS_SD_VALUE, JSON.stringify(keywords))
      break
    }
    case UPDATE_KEYWORDS_METRICS.failed: {
      const keywords = omit(
        state.keywords,
        action.payload.map((kw) =>
          generateKey([kw.lang, kw.loc_id, kw.keyword]),
        ),
      )

      resultState = {
        ...state,
        keywords,
        isFailed: true,
      }
      KeywordsSDBank.setItem(KEY_KEYWORDS_SD_VALUE, JSON.stringify(keywords))

      break
    }
    default:
      return state
  }

  if (!resultState) {
    resultState = {
      ...state,
    }
  }
  return resultState
}

export default sdManagerReducer
